/* eslint-disable camelcase */
import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  PaginationPayload,
  PostsListResponse,
  singlePostResponse,
  CommentsPaginationPayload,
  CommentsListResponse,
} from './types'

const API_ENDPOINT = '/api/v1/fitness'

const PostApi = createApi({
  reducerPath: 'postsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['postsApi'],
  endpoints: (builder) => ({
    getPostsList: builder.query<PostsListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/admin_posts_list/?q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
      transformResponse: (response: PostsListResponse) => {
        return response
      },
    }),

    getCommentsListById: builder.query<CommentsListResponse, CommentsPaginationPayload>({
      query: ({ page = 1, pageSize = 3, id = 0 }) => ({
        url: `${API_ENDPOINT}/post_comments/?post_id=${id}&page=${page}&page_size=${pageSize}`,
        method: 'GET',
      }),
      transformResponse: (response: CommentsListResponse) => {
        return response
      },
    }),

    getPostDetailsById: builder.query<singlePostResponse, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_feed_post/${id}/`,
        method: 'GET',
      }),
      transformResponse: (response: singlePostResponse) => {
        return response
      },
    }),

    deletePost: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_feed_post/${id}/`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useGetPostsListQuery,
  useGetPostDetailsByIdQuery,
  useGetCommentsListByIdQuery,
  useDeletePostMutation,
} = PostApi
export default PostApi
